import { useEffect } from "react";
import { Hooks } from "../layout/utils/hooks";
import { useAppSelector } from "../redux/hooks";
import { GlobalHooks } from "../utils/Hooks";

const StatsPodcastsIntegrated = ({language ="fr", token}) => {
  const videoToken = useAppSelector((state) => state.LayoutReducer.STAT_VIDEO_URL)
  const {cookies} = GlobalHooks()

  const OPTIONS = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Authorization" : "Bearer "+ cookies.authToken,
    },
  };


  const newStatsVideosIframe = "https:" +
    window.process.env.FO_STATS_URL + "/podcast"
    +  "?lng=" + language + "&token=" + token
  
    return (
      <iframe
        id="iframe_statsVideos_display"
        src={newStatsVideosIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default StatsPodcastsIntegrated